import * as z from "zod/v4";

export const getYotpoIntegration = {
  name: "getYotpoIntegration" as const,
  input: z.object({}),
  output: z.object({
    exists: z.boolean(),
    enableWebhooks: z.boolean().optional(),
  }),
};
